import React from "react"
import {
  Box,
  OutlinedInput,
  FormHelperText,
  makeStyles,
  Theme,
} from "@material-ui/core"
import { InputLabel } from "../@citydna/common/InputLabel"
import { useFormContext } from "react-hook-form"
import { useCommonFieldProps } from "./CommonFieldPropsContext"

/** Scoped @material-ui/core stylesheet */
const useStyles = makeStyles<Theme>(theme => ({
  helperText: {
    fontSize: 10,
  },
}))

export const CommonFieldFields: React.FC = () => {
  /** Get common schema field props */
  const { field, index } = useCommonFieldProps()

  /** Form value prefix */
  const prefix = `fields[${index}]`
  const aliasInputName = `${prefix}.alias`
  const nameInputName = `${prefix}.name`
  const descriptionInputName = `${prefix}.description`
  const orderInputName = `${prefix}.order`

  /** Get react-hook-form context */
  const { register, errors } = useFormContext()

  /** Get scoped CSS classes */
  const classes = useStyles()

  return (
    <>
      <Box mb={2}>
        <InputLabel htmlFor={aliasInputName}>Field label</InputLabel>
        <OutlinedInput
          inputRef={register({ required: true })}
          name={aliasInputName}
          id={aliasInputName}
          defaultValue={field.alias}
          fullWidth
          color="secondary"
          error={errors[aliasInputName]}
        />
      </Box>
      <Box mb={2}>
        <InputLabel htmlFor={nameInputName}>Field key</InputLabel>
        <OutlinedInput
          inputRef={register({ required: true })}
          name={nameInputName}
          id={nameInputName}
          defaultValue={field.name || ""}
          fullWidth
          color="secondary"
        />
        <FormHelperText className={classes.helperText}>
          Warning: changing this after it is set will remove all content for
          this field from all features.
        </FormHelperText>
      </Box>
      <Box mb={2}>
        <InputLabel htmlFor={descriptionInputName}>
          Field description/helper text
        </InputLabel>
        <OutlinedInput
          inputRef={register}
          name={descriptionInputName}
          id={descriptionInputName}
          multiline={true}
          rows={5}
          color="secondary"
          fullWidth
          defaultValue={field.description}
        />
      </Box>
      <input
        ref={register()}
        type="hidden"
        name={orderInputName}
        defaultValue={field.order || index}
      />
    </>
  )
}
